import type { ReactElement } from 'react';
import { forwardRef } from 'react';
import { twMerge } from 'cn';
import { DriverStatusStyles } from './constants.js';
import type { DriverStatusBadgeProps } from './types.js';

/** Driver status `<Badge>` component. */
export const DriverStatusBadge = forwardRef<HTMLDivElement, DriverStatusBadgeProps>(
  ({ className, status, ...props }, forwardedRef): ReactElement => {
    const styles = DriverStatusStyles[status];

    return (
      <div
        className={twMerge(
          'inline-flex items-center justify-center rounded-4 px-12 py-6 text-sm font-medium uppercase tracking-wide',
          styles.bg,
          styles.text,
          className
        )}
        ref={forwardedRef}
        {...props}
      >
        {styles.label}
      </div>
    );
  }
);

DriverStatusBadge.displayName = 'DriverStatusBadge';
